import React from "react";
import { Button, Grid, Typography } from "@material-ui/core";

import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Rating from "@material-ui/lab/Rating";
import { ClientServicingCss as Styles } from "../../components/clientServicing/css/ClientServicingCss";
import { ErrorCommon, TextField, TextFieldCommon } from "../../components/formikFormInputs";
import { Formik } from "formik";
import { useActions } from "../../actions";
import * as Actions from "../../actions/account";
import { Label } from "../../components/formInputs";

export default function ServicingFeedDialogContent(props:any) {
    console.log("props- ServicingFeedDialogContent", props);
    const {setShowDialog} = props
    const classes = Styles();
    const [completeFeedback, setcompleteFeedback] = React.useState<number | null>(0);
    const accountActions = useActions(Actions);

    const submitFormik = async (values: any, setSubmitting: Function, resetForm: Function) => {
        await accountActions.saveServicingFeedback(values);
        setSubmitting(false);
        setShowDialog(false)
        resetForm();
    };

    const initialValues = {
        completeFeedback: "",
        portalEasy: "",
        clientsEasy: "",
        techDifficulty: "",
        recommend: "",
        helpful: "",
        suggestionsMessage: ""
    };
    const validate = ((value: any) => {
        let errors: any = {};
        if (!value.completeFeedback) {
            errors.completeFeedback = "Required";
        }
        if (!value.portalEasy) {
            errors.portalEasy = "Required";
        }
        if (!value.clientsEasy) {
            errors.clientsEasy = "Required";
        }
        if (!value.techDifficulty) {
            errors.techDifficulty = "Required";
        }
        if (!value.recommend) {
            errors.recommend = "Required";
        }
        if (!value.helpful) {
            errors.helpful = "Required";
        }
        if (!value.suggestionsMessage) {
            errors.suggestionsMessage = "Required";
        }
        if (value.suggestionsMessage && value.suggestionsMessage.length > 250 ) {
            errors.suggestionsMessage = "Max Limit 250 Word";
        }
        return errors;
    });

    const fields = [
        {
            name: "portalEasy",
            id: "portalEasy",
            label: <Label label={"Did you find the servicing portal easy to navigate?"} required={true}/>,

        },
        {
            name: "clientsEasy",
            id: "clientsEasy",
            label: <Label label={"Were you able to find the information you needed for your clients easily?"} required={true} />,

        },
        {
            name: "techDifficulty",
            id: "techDifficulty",
            label: <Label label={"Did you experience any technical difficulties while using the servicing portal?"} required={true} />,

        },

        {
            name: "recommend",
            id: "recommend",
            label: <Label label={"Would you recommend the servicing portal to other agents?"} required={true} />,

        },
        {
            name: "helpful",
            id: "helpful",
            label: <Label label={"Was the servicing portal helpful in managing your clients policies?"} required={true} />,

        }
    ];

    const fieldObj = [
        {
            name: "suggestionsMessage",
            id: "suggestions",
            label: <Label label={"What suggestions do you have for improving the servicing portal?"} required={true}/>,
            placeholder: "Enter",
            isRequired: true,
            component: TextField,
            variant: "outlined",
            className: "w100",
            multiline: true,
            rows: 4,
            touched:true
        },
    ];


    return (
                <Formik
                        initialValues={initialValues}
                        enableReinitialize={true}
                        validate={values => validate(values)}
                        validateOnChange={true}
                        onSubmit={(values, { setSubmitting, resetForm }) =>
                                submitFormik(values, setSubmitting, resetForm)
                        }

                >
                    {({
                          values,
                          setFieldValue,
                          errors,
                          touched,
                          handleChange,
                          handleSubmit,
                          // isSubmitting,
                          dirty,
                      }) => (<form onSubmit={handleSubmit}>

                                    <Grid container spacing={2} alignItems="center">
                                        {
                                            fields.map((field, idx) => (
                                                    <>
                                                        <Grid item xs={12} md={9}>
                                                            <Typography variant="body1" className="mb0">{field.label}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={3}>
                                                            <ToggleButtonGroup
                                                                    className="floatRight floatLeftxs mb15sm"                                            size="medium"
                                                                    color={"primary"}
                                                                    exclusive
                                                                    id={field.name}
                                                                    value={values[field.name] === "Yes" ? "Yes" : (values[field.name] == "No") ? "No" : ""}
                                                                    onChange={(ev: any, value: any) => {
                                                                        if (value === "Yes") {
                                                                            setFieldValue(field.name, value);
                                                                        }
                                                                        if (value === "No") {
                                                                            setFieldValue(field.name, value);
                                                                        }
                                                                        if (value === null) {
                                                                            setFieldValue(field.name, "");
                                                                        }
                                                                    }}
                                                            >
                                                                <ToggleButton value={"Yes"}
                                                                              className={values[field.name] === "Yes" ? "active" : ""}>
                                                                    Yes
                                                                </ToggleButton>
                                                                <ToggleButton value={"No"}
                                                                              className={values[field.name] === "No" ? "active" : ""}>
                                                                    No
                                                                </ToggleButton>
                                                            </ToggleButtonGroup>
                                                        </Grid></>))
                                        }
                                        <Grid item xs={12}>
                                            <Typography variant="body1" className="floatLeft w100">
                                                <span className={classes.w70 + " " + classes.floatLeft + " w100sm "}>How would you rate the overall user experience of the servicing portal?</span>
                                                <Rating
                                                        className="floatRight"
                                                        name="completeFeedback"
                                                        value={completeFeedback}
                                                        onChange={(event, newValue) => {
                                                            setcompleteFeedback(newValue);
                                                            setFieldValue('completeFeedback', newValue);
                                                        }}
                                                />
                                            </Typography>
                                        </Grid>
                                       <Grid xs={12}>
                                        {
                                            fieldObj.map((field, index) => {
                                                return (
                                                        <div className="mt30" key={index}>
                                                            <TextFieldCommon
                                                                    {...field}
                                                                    values={values}
                                                                    onChange={handleChange}

                                                            />
                                                            {errors.suggestionsMessage && (
                                                                    <span className="colorRed f14">{errors.suggestionsMessage}</span>
                                                            )}

                                                            <ErrorCommon errors={errors} name={field.name}
                                                                         touched={touched}/>
                                                        </div>
                                                );
                                            })
                                        }
                                        <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className="mb20 floatRight mt15"
                                                size="medium"
                                                disabled={!dirty || !completeFeedback || Object.keys(errors).length > 0}
                                        >
                                            Submit Ratings
                                        </Button>


                                    </Grid>
                                </Grid>
                        </form>
                )}
            </Formik>
    );
}